import React from "react";
import { withRouter } from "react-router";
import {Tooltip} from 'antd';
import moment from 'moment';
import  PropTypes from 'prop-types';
import TiffFormTable from "./TiffFormTable";
import TitleNode from "../../../../../CommonComponents/CustomNodes/TitleNode/TitleNode";
import Preloader from "../../../../../CommonComponents/Preloader/Preloader";
import FlowCard from "../../../../../CommonComponents/FlowCard/FlowCard";
import Buttons from "./Buttons";
import { initiateTracking } from "../../../../../utils/commonUtil";
import { DataHeading, DataValue, CustomCheckbox } from "../../../../../CommonComponents/commonStyles";
import {
  Title,
  Description,
  DescriptionSpan,
  FlexCenterWrapper,
  DesktopView,
  MobileView,
  DesktopTabFlex,
  InlineBox,
  DollarAmount,
  FooterText,
  ClearFixDiv,
  CurrencyDiv,
  Divider,
  BalanceMessage,
  PoolNameReview,
  UnderlyingContent
} from "./styles";
import {
  dollarText,
  pricePerUnitText,
  plainValue,
  replaceSelect
} from "../../../../../utils/replacer";
import {
  getPrimaryAccount,
  getAccountData
} from "../../../../../utils/sessionUtil";
import CurrencyInput from "../../../../../CommonComponents/CurrencyInput/CurrencyInput";

export const nextSumit = (props) => {
  if(props.nextIntoValidation()) {
      initiateTracking('update', 'Recommend an Exchange', "Step 1 Recommend exchange from", "Update - TIFF Exchange INTO");
      const limit = props.firstTiffExchnageFlag ? 50000 : 10000;
      if (props.totalDollar >= limit) {
        props.history.push("/investments/recommend-an-exchange-tiff/review");
        props.setStepOne();
      } else {
        props.triggerPopUp();
      }
  }
};

export const renderTitleGrid = pool => {
  return <PoolNameReview>{replaceSelect(pool.poolName)}</PoolNameReview>;
};

export const styleConfig = () => {
  return {
    alternatingBg: true,
    cardBorder: false,
    cardDivider: true,
    cardPadding: true
  };
};

export const renderFixGrid = ({ pool, gridName, props }) => {
  switch (gridName) {
    case "availableBalance": {
      return (
        <>
          <TitleNode title={gridName} />
          <DataValue>{props.isEdit ? props.cloneExchangeIntoPool ? dollarText(pool[gridName] + +props.cloneExchangeIntoPool[pool.poolId]): dollarText(pool[gridName]) : dollarText(pool[gridName])}</DataValue>
        </>
      );
    }
    case "availableUnits": {
      return (
        <>
          <TitleNode title={gridName} />
          <DataValue>{pool[gridName]}</DataValue>
        </>
      );
    }
    case "pricePerUnit": {
      const perUpdatedOn = 'Price updated on ' + moment(moment.tz(pool.dateOfPricePerUnit, 'America/New_York')).format('MM/DD/YYYY')
      return (
        <>
          <TitleNode title={gridName} />
          <Tooltip placement="bottomLeft" title={perUpdatedOn}>
            <UnderlyingContent>
              {pricePerUnitText(pool[gridName], pool.isRise)}
            </UnderlyingContent>
          </Tooltip>
        </>
      );
    }
  }
};

export const destObj = (pool, index, props) => {
  return [
    {
      name: "poolName",
      gridWidth: "100",
      type: "TitleGrid",
      render: renderTitleGrid(pool),
      noBorderBottom: true,
      ptop: true
    },
    {
      name: "availableBalance",
      gridWidth: "50",
      type: "FixGrid",
      render: renderFixGrid({ pool, gridName: "availableBalance", props }),
      ptop: true,
      pbottom: true
    },
    {
      name: "availableUnits",
      gridWidth: "50",
      type: "FixGrid",
      render: renderFixGrid({ pool, gridName: "availableUnits", props }),
      ptop: true,
      pbottom: true
    },
    {
      name: "pricePerUnit",
      gridWidth: "50",
      type: "FixGrid",
      render: renderFixGrid({ pool, gridName: "pricePerUnit", props }),
      ptop: true,
      pbottom: true
    },
    {
      name: "Dollars",
      type: "Input",
      gridWidth: "50",
      render: renderInputBox({ pool, gridName: "Dollars", props }),
      ptop: true,
      pbottom: true
    }
  ];
};


export const renderInputBox = ({ pool, gridName, props }) => {
  return (
    <>
      <TitleNode title={gridName} />
      <CurrencyInput data-test="input"
        addonBefore="$"
        value={props.inputValues && props.inputValues[pool.poolId]}
        onChange={e => {
          const { value } = e.target;
          if (value <= pool.availableBalance) {
            props.setInputValues({
              key: pool.poolId,
              value
            });
          }
        }}
        onBlur={(e) => props.blurOutDollar(pool.poolName, e.target.value, pool.availableBalance, pool.poolId)}
      />
    </>
  );
};


 const TIFFRecommendAnExchangeFrom = props => {
  const nextForm = page => {
    if(props.nextFromValidation()) {
      props.setStepOne();
      if (page === "next") {
        props.history.push("/investments/recommend-an-exchange-tiff/allocate");
      } else if (page === "update") {
        initiateTracking('update', 'Recommend an Exchange', "Step 1 Recommend exchange from", "Update - TIFF Exchange FROM");
        props.history.push("/investments/recommend-an-exchange-tiff/review");
      }
    }  
  };

  

   const update = type => {
    if(props.editUpdateValidation(type)) {
      initiateTracking('update', 'View and Edit Exchange', `${type === "from" ? "Amount to be exchanged from TIFF" : "Recommend exchange from" }`, `Update - TIFF Exchange ${type === "from" ? "FROM" : "INTO"}`);
      var poolTo = [];
      var poolFrom = [];

      if (type === "from") {
        poolFrom = [
          {
            poolId: 17,
            pool: "TIFF Multi-Asset Pool",
            value: props.valueExchangeFromTiff
          }
        ];
        poolTo = props.getTiffDetails.exchangeTo;
      } else {
        const limit = props.firstTiffExchnageFlag ? 50000 : 10000;
        if (props.totalDollar >= limit) {
          props.poolData.map(obj => {
            for (var key in props.inputValues) {
              if (props.inputValues.hasOwnProperty(key)) {
                if (
                  Number(obj.poolId) === Number(key) &&
                  props.inputValues[key] != "" &&
                  parseInt(props.inputValues[key]) !== 0
                ) {
                  poolFrom.push({
                    poolId: obj.poolId,
                    pool: obj.poolName,
                    value: props.inputValues[key],
                  });
                }
              }
            }
          });
          poolTo = [
            {
              poolId: 17,
              pool: "TIFF Multi-Asset Pool",
              percentage: 100
            }
          ];
        }
        else {
          props.triggerPopUp();
        }
      }
      props.submitUpdateTiff({
        method: "PUT",
        url: `/donor-portal/api/exchange/${
          getPrimaryAccount().userId
          }/updateSingleExchange`,
        data: {
          partyId: getAccountData().partyId, //partyId
          txnId: props.location.params.id,
          startDate: moment(props.getTiffDetails.exchangeStartDate).format(
            "YYYY-MM-DD"
          ),
          exchangeType: "Custom Exchange",
          category: "Single Exchange",
          unit: props.getTiffDetails.instructionType,
          exchangeFrom: poolFrom,
          exchangeTo: poolTo
        },
        selectedTiffOption: props.type
      });
    }
  };
  

 

  


  

   const enableNextButton = () => {
    const percentage = (props.totalDollar / props.availableBalance) * 100;
    return (percentage > 90);
  };

  if (props.type === "exchangeintoTIFF") {
    if (props.accDataLoading) return <Preloader data-test = "loader"/>;
    return (
      <>
        <Title data-test="title">Recommend exchange from</Title>
        <Description>
          Decide the amount to be exchanged into the TIFF Multi-asset Fund.
        </Description>
        {props.poolData && props.poolData.length !== 0 ? <>
          <DesktopView>
            <TiffFormTable
              investmentPools={props.poolData}
              inputValues={props.inputValues}
              setInputValues={props.setInputValues}
              totalDollar={props.totalDollar}
              blurOutDollar={props.blurOutDollar}
              tiffPoolName={props.tiffPoolName}
              cloneExchangeIntoPool={props.cloneExchangeIntoPool}
              isEdit={props.isEdit}
            />
          </DesktopView>
          <MobileView>
            {props.poolData &&
              props.poolData.map((pool, index) => {
                if (pool.poolName != props.tiffPoolName) {
                  return (
                    <FlowCard
                      cardConfig={destObj(pool, index, props)}
                      styleConfig={styleConfig()}
                      index={index}
                      key={index}
                      scrollId="fromFlowCard"
                    />
                  );
                }
              })}
            <ClearFixDiv>
              <FooterText>Amount to be exchanged to TIFF: </FooterText>
              {props.totalDollar == 0 ? <DollarAmount className="left">$0.00</DollarAmount> : <DollarAmount className="left">{dollarText(props.totalDollar)}</DollarAmount>}
            </ClearFixDiv>
          </MobileView>
        </> : <Preloader />}
        {props.isDisabled ? (
          <Buttons
            type={4}
            opacity={"1"}
            width={props => props.theme.buttonWidth.ghostButton}
            onClickUpdate={() => update("into")}
            //disabled={props.enableUpdateInto}
            onClickExit={props.onExitClick}
            onClickCancel={() => {
              initiateTracking('cancel', 'View and Edit Exchange', "Recommend exchange from", "Cancel - TIFF Exchange INTO");
              props.history.push(
                `/view-edit-tiff-into/${props.location.params.id}/edit`
              );
            }}
          />
        ) : (
            <Buttons
              type={props.history.location.params ? 4 : 1}
              //opacity={props.totalDollar == 0 ? "0.3" : "1"}
              width={props => props.theme.buttonWidth.ghostButton}
              onClickNext={() => nextSumit(props)}
              onClickUpdate={() => nextSumit(props)}
              //disabled={props.history.location.params ? props.enablePillUpdateInto() : (props.totalDollar == 0 || enableNextButton())}
              enableNextButton={enableNextButton()}
              onClickCancel={() => {
                initiateTracking('cancel', 'Recommend an Exchange', "Step 1 Recommend exchange from", "Cancel - TIFF Exchange INTO");
                props.history.push({
                  pathname: `/investments/recommend-an-exchange-tiff/review`
                });
              }}
            />
          )}
      </>
    );
  } else {
    if (props.accDataLoading && props.tiffBalanceAmount != 0)
      return <Preloader />;
    return (
      <>
        <Title>Recommend exchange from</Title>
        <Description>
          Decide the amount to be exchanged from the TIFF Multi-asset Fund.
        </Description>
        <DesktopTabFlex>
          <DataHeading>
            Balance available for exchange:
          </DataHeading>
          <InlineBox>{props.tiffBalanceAmount ? dollarText(props.tiffBalanceAmount) : <></>}</InlineBox>
        </DesktopTabFlex>
        {props.tiffBalanceAmount ? <FlexCenterWrapper>
          <DescriptionSpan className="ml0">Enter the amount</DescriptionSpan>
          <CurrencyDiv>
            <CurrencyInput
              label="dollar input"
              id="btnEnterAmount"
              addonBefore="$"
              placeholder="Enter the Amount"
              value={props.valueExchangeFromTiff}
              onChange={e => {
                props.setIntoTiff(plainValue(e.target.value));
              }}
              className="py0"
            />
          </CurrencyDiv>
          <CustomCheckbox
            aria-label="checkbox input"
            id="chkExchangeEntireBalance"
            onChange={e => {
              props.checked(e.target.checked);
            }}
            checked={props.tiffBalanceAmount == props.valueExchangeFromTiff}
          >
            <DescriptionSpan>Exchange entire balance</DescriptionSpan>
          </CustomCheckbox>
        </FlexCenterWrapper> : <Preloader styling="p0 w25" />}
        {((props.valueExchangeFromTiff === null || props.valueExchangeFromTiff === "" || props.enableUpdateFromStepOne()) && !props.isDirty) ? "" : <BalanceMessage>The minimum amount you can invest from TIFF is either 50,000 or entire balance (whichever is lower)</BalanceMessage>}
        <Divider />
        {props.isDisabled ? (
          <Buttons
            type={4}
            opacity={"1"}
            width={props => props.theme.buttonWidth.ghostButton}
            onClickUpdate={() => update("from")}
            //disabled={props.enableUpdateFromStepOne() || props.enableFromStepOne()}
            onClickExit={props.onExitClick}
            onClickCancel={() => {
              initiateTracking('cancel', 'View and Edit Exchange', "Amount to be exchanged from TIFF", "Cancel - TIFF Exchange FROM");
              props.history.push(
                `/view-edit-tiff-from/${props.location.params.id}/edit`
              );
            }}
          />
        ) : (
            <Buttons
              type={props.history.location.params ? 4 : 1}
              width={props => props.theme.buttonWidth.ghostButton}
              onClickNext={() => nextForm("next")}
              onClickUpdate={() => nextForm("update")}
              //disabled={props.history.location.params ? (props.enablePillUpdateFromStepOne() || props.enableFromStepOne()) : (props.valueExchangeFromTiff === null || props.enableFromStepOne())}
              onClickCancel={() => {
                initiateTracking('cancel', 'Recommend an Exchange', "Step 1 Recommend exchange from", "Cancel - TIFF Exchange FROM");
                props.history.push({
                  pathname: `/investments/recommend-an-exchange-tiff/review`
                });
              }}
            />
          )}
      </>
    );
  }
};

TIFFRecommendAnExchangeFrom.propTypes = {
  setInputValues: PropTypes.func,
  inputValues: PropTypes.object,
  cloneExchangeIntoPool: PropTypes.object,
  isEdit: PropTypes.bool,
  inputValuesLoading: PropTypes.bool,
  setIntoTiff: PropTypes.func,
  checked: PropTypes.func,
  setStepOne: PropTypes.func,
  blurOutDollar: PropTypes.func,
  triggerPopUp: PropTypes.func,
  onExitClick: PropTypes.func,
  enablePillUpdateInto: PropTypes.func,
  enableFromStepOne: PropTypes.func,
  enableUpdateFromStepOne: PropTypes.func,
  enablePillUpdateFromStepOne: PropTypes.func,
  nextFromValidation: PropTypes.func,
  nextIntoValidation: PropTypes.func,
  editUpdateValidation: PropTypes.func,
}

export default withRouter(TIFFRecommendAnExchangeFrom);